module.exports = __webpack_public_path__ + "static/water_glacier16-134d02c9b56cb31975be9faf1436d9b8.jpg";